import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { useToast, ToastContext } from '../toast/ToastContext.js';
import { ToastManager } from '../toast/ToastManager.js';
import React__default from 'react';
import '../../styles/euclid.css.js';
import '../../styles/graphik.css.js';
import '../../styles/matter.css.js';
import { useColorMode, ColorModeContext } from './ColorModeContext.js';
import { useWindowSize, WindowSizeContext } from './WindowSizeContext.js';
import { YoungThemeProvider } from './YoungThemeProvider.js';
var YoungProvider = function YoungProvider(_a) {
  var children = _a.children,
    options = _a.options;
  var windowSize = useWindowSize();
  var toast = useToast();
  var colorMode = useColorMode(__assign({}, options === null || options === void 0 ? void 0 : options.colorMode));
  return React__default.createElement(ColorModeContext.Provider, {
    value: colorMode
  }, React__default.createElement(YoungThemeProvider, {
    colorMode: colorMode.colorMode
  }, React__default.createElement(WindowSizeContext.Provider, {
    value: windowSize
  }, React__default.createElement(ToastContext.Provider, {
    value: toast
  }, children, React__default.createElement(ToastManager, __assign({}, options === null || options === void 0 ? void 0 : options.toast))))));
};
export { YoungProvider };